// extracted by mini-css-extract-plugin
module.exports = {"container":"Spacer_container__ZfGkY"};